import arabicTransform from "./transforms/arabic";
import canadianSyllabicsLargeTransform from "./transforms/canadianSyllabicsLarge";
import circledTransform from "./transforms/circled";
import cjkTransform from "./transforms/cjk";
import cyrilicThaiMixTransform from "./transforms/cyrilicThaiMix";
import dashedTransform from "./transforms/dashed";
import dashesTransform from "./transforms/dashes";
import flippedTransform from "./transforms/flipped";
import flippedReversedTransform from "./transforms/flippedReversed";
import heartTransform from "./transforms/heart";
import longLettersTransform from "./transforms/longLetters";
import ordinalTransform from "./transforms/ordinal";
import pointsTransform from "./transforms/points";
import serifTransform from "./transforms/serif";
import simpleReverseTransform from "./transforms/simpleReverse";
import sniperTransform from "./transforms/sniper";
import starTransform from "./transforms/star";
import strokedTransform from "./transforms/stroked";
import thaiStyleTransform from "./transforms/thaiStyle";
import triangleTransform from "./transforms/triangle";

const fonts = [
  cyrilicThaiMixTransform,
  longLettersTransform,
  cjkTransform,
  strokedTransform,
  ordinalTransform,
  thaiStyleTransform,
  arabicTransform,
  circledTransform,
  flippedTransform,
  flippedReversedTransform,
  canadianSyllabicsLargeTransform,
  simpleReverseTransform,
  pointsTransform,
  dashedTransform,
  serifTransform,
  heartTransform,
  starTransform,
  dashesTransform,
  triangleTransform,
  sniperTransform,
];

jQuery(document).ready(function () {
  new ClipboardJS(".NicknameGeneratorCopyButton");

  fonts.forEach((font, index) => {
    const inputEl = jQuery(
      `<input data-index="${index}" placeholder="${font(
        "nickname"
      )}" readonly class="NicknameGeneratorResultInput" id="NicknameResult-${index}" type="text" />`
    );

    const copyButton = jQuery(
      `<button disabled class="NicknameGeneratorCopyButton" data-clipboard-target="#NicknameResult-${index}">
        <img src="${WPURLS.copySvg}" alt="Copy" />
      </button>`
    );

    const elementsContainer = jQuery(
      `<div class="NicknameGeneratorInputContainer"></div>`
    );

    elementsContainer.append(inputEl);
    elementsContainer.append(copyButton);

    const isSecondColumn = index % 2 === 1;

    jQuery(".ResultsContainer").append(elementsContainer);
  });

  jQuery("#nickname").keyup((ev) => {
    if (ev.target.value.length > 0) {
      jQuery(".NicknameGeneratorCopyButton").prop("disabled", false);
    }

    if (ev.target.value.length >= 13) {
      ev.preventDefault();
      return;
    }

    fonts.forEach((font, index) => {
      const result = font(ev.target.value);
      const resultsEl = jQuery(`.ResultsContainer input[data-index=${index}]`);

      if (result.length > 12) {
        resultsEl.parent().hide();
      }

      if (resultsEl.is(":hidden") && result.length <= 12) {
        resultsEl.parent().show();
      }

      resultsEl.val(font(ev.target.value).substring(0, 12));
    });
  });
});
